import firebase from '@/api/firebase'
import { store } from '@/store'
import { toast } from '@/api/tools'
import router from '@/router'

export const authUser = (): Promise<firebase.User | null> => {
  return new Promise( (resolve, reject) => {
    if (store && store.auth.signedIn()) {
      resolve(store.auth.getUser())
    } else {
      const unsubscribe = firebase.auth().onAuthStateChanged(user => {
        resolve(user)
        unsubscribe()
      }, (error) => {
        reject(error)
        unsubscribe()
      })
    }
  })
}

const signIn = async (provider: firebase.auth.AuthProvider) => {
  try {
    const redirect = router.currentRoute.value.query.redirect as string || '/'       
    const auth = await firebase.auth().signInWithPopup(provider)
    redirect && router.push(redirect)
    store.modal.hideModal('SignIn')
    return auth
  } catch(err) {
    toast({title: 'Fejl under login', msg: err, type: 'error'})
  }
}

export const signInWithGoogle = async () => {
  const provider = new firebase.auth.GoogleAuthProvider()
  return signIn(provider)
}

export const signInWithFacebook = async () => {
  const provider = new firebase.auth.FacebookAuthProvider()
  return signIn(provider)
}

export const signOut = async () => {
  return firebase.auth().signOut()
}